import React, { Component } from 'react';
import { Button, Modal, Form, Spin, Input, Col, Row, Select } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { actions } from "store";
import { FormItem } from 'utils/form_helpers';
import { Error, PhotoUpload } from 'components/common';


class BannerForm extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { actions, banner, siteId } = this.props;
        const instance = banner.editObject;

        let data = Object.assign({ site: siteId }, values);
        if (instance && instance.id) {
          data.id = instance.id;
        }
        if (data.bg_image) {
          data.bg_image = data.bg_image.id;
        }
        console.log(data);

        actions.bannerUpdate(data);
      }
    });
  };

  close = () => {
    const { actions } = this.props;
    actions.bannerShowEditForm({ show: false });
  };

  render() {
    const { form, banner } = this.props;
    const { showEditForm, updateStatus, editObject } = banner;
    const instance = editObject;

    const error = updateStatus.error || {};
    const errorData = error.data || {};

    const isLoading = banner.updateStatus.isLoading;

    return (
      <Modal
        width={640}
        visible={showEditForm}
        title="Редактирование баннера"
        onCancel={this.close}
        maskClosable={false}
        footer={[
          <Button key="cancel" onClick={this.close} disabled={isLoading}>Отмена</Button>,
          <Button key="submit" type="primary" loading={isLoading} onClick={this.handleSubmit}>
            Сохранить
          </Button>,
        ]}
      >
        <Spin spinning={isLoading}>
          <Form onSubmit={this.handleSubmit}>
            <Error errors={errorData.non_field_errors}/>

            <Row gutter={32}>
              <Col span={17}>
                <div className="form-block">
                  <FormItem
                    form={form}
                    instance={instance}
                    name="position"
                    label="Позиция"
                    required={true}
                    errorData={errorData}
                  >
                    <Input size="large" style={{ width: '100%' }}/>
                  </FormItem>

                  <FormItem
                    form={form}
                    instance={instance}
                    name="name"
                    label="Название"
                    required={true}
                    errorData={errorData}
                  >
                    <Input size="large" style={{ width: '100%' }}/>
                  </FormItem>

                  <FormItem
                    form={form}
                    instance={instance}
                    name="link"
                    label="Ссылка"
                    required={true}
                    errorData={errorData}
                  >
                    <Input size="large" style={{ width: '100%' }}/>
                  </FormItem>

                  <FormItem
                    form={form}
                    instance={instance}
                    name="rel"
                    label="Rel"
                    required={true}
                    errorData={errorData}
                  >
                    <Input size="large" style={{ width: '100%' }}/>
                  </FormItem>

                  <FormItem
                    form={form}
                    instance={instance}
                    name="text"
                    label="Текст"
                    required={false}
                    errorData={errorData}
                  >
                    <Input.TextArea size="large" autosize={{ minRows: 3 }}/>
                  </FormItem>
                </div>
              </Col>

              <Col span={7}>
                <FormItem
                  form={form}
                  instance={instance}
                  name="file"
                  label="Картинка"
                  required={true}
                  errorData={errorData}
                  valuePropName="fileList"
                >
                  <PhotoUpload
                    mode="single"
                    title="Загрузить картинку"
                  />
                </FormItem>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Modal>
    );
  }
}

const WrappedForm = Form.create()(BannerForm);

function mapStateToProps(state) {
  return {
    banner: state.banner,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.banner), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WrappedForm);

